import React, { useMemo } from "react";
import { Box, Button, Dialog, Stack, Typography } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import SkillAgentMoodboardDetail from "./SkillAgentMoodboardDetail";
import { buildCaratulaBoardApi } from "../../api/Skills/skillAgentCaratulasApi";

/**
 * Editor de mesas de una carátula: reutiliza MoodboardDetail vía boardApi.
 */
export default function SkillAgentCaratulaEditor({
  open,
  caratulaId,
  caratulaName = "",
  onClose,
  onChanged,
}) {
  const boardApi = useMemo(() => buildCaratulaBoardApi(), []);

  if (!open || !caratulaId) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{ sx: { bgcolor: "background.default" } }}
    >
      <Box
        sx={{
          height: "100%",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            px: 1.5,
            py: 1,
            borderBottom: "1px solid",
            borderColor: "divider",
            flexShrink: 0,
            bgcolor: "background.paper",
          }}
        >
          <Button
            startIcon={<ArrowBackOutlinedIcon />}
            onClick={onClose}
            size="small"
          >
            Volver a carátulas
          </Button>
          <Typography fontWeight={800} noWrap sx={{ flex: 1, minWidth: 0 }}>
            Plantilla · {caratulaName || `#${caratulaId}`}
          </Typography>
        </Stack>
        <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
          <SkillAgentMoodboardDetail
            key={`caratula-${caratulaId}`}
            moodboardId={caratulaId}
            boardApi={boardApi}
            onChanged={onChanged}
            onDeleted={onClose}
          />
        </Box>
      </Box>
    </Dialog>
  );
}
